import React from "react";
import classNames from "classnames";
import styles from "../../../styles";
import { isIosBangsDevice } from "../../../utils/system";
import "./index.less";
import { IGoal } from "../../../service/activity/interface";
import { tempBtnColorSelecor } from "../../../store/common/selector";
import { connect } from "react-redux";

const PREFIX = "SignalGoalSelector";

type IProps = {
  goals: Array<IGoal>;
  onSelectGoal: (goal_id: number) => void;
} & ReturnType<typeof mapStateToProps>;

interface IState {
  goal_id: number;
}

class ClubActivityGoal extends React.Component<IProps, IState> {
  private units: Array<string>;

  constructor(props: IProps) {
    super(props);
    this.units = ["", "千米", "秒", "大卡", "次"];
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public state: IState = {
    goal_id: 0,
  };

  componentWillMount() {
    const { goals } = this.props;
    if (goals && goals.length) {
      this.setState({ goal_id: goals[0].goal_id });
    }
  }

  public onPressGoal(item: IGoal): void {
    this.setState({ goal_id: item.goal_id });
  }

  public handleSubmit(): void {
    this.props.onSelectGoal(this.state.goal_id);
  }

  _getSportTypeCN = (sportType: string): string => {
    const sportCNs = ["健走", "跑步", "骑行"];
    const sportTypeNum = Number(sportType);

    if (sportTypeNum < 101) {
      return sportCNs[sportTypeNum];
    } else {
      return sportTypeNum < 102 ? `课程` : "动作";
    }
  };

  // 渲染目标dom
  public renderGoals(item: IGoal): JSX.Element {
    const { goal_id } = this.state;
    const { tempBtnColor } = this.props;
    const activeStyle =
      item.goal_id === goal_id ? { color: tempBtnColor } : null;
    const sports_type = item.sports_type
      .split(",")
      .map((item) => this._getSportTypeCN(item));
    return (
      <div
        key={item.goal_id}
        style={{ ...styles.goalItem, ...activeStyle }}
        onClick={this.onPressGoal.bind(this, item)}
        className={`${PREFIX}-goal`}
      >
        {item.goal_name ? (
          <span>{item.goal_name}</span>
        ) : (
          <React.Fragment>
            <span style={{ marginRight: "3px" }}>{sports_type.join("/")} </span>
            <span>{this.getGoalUnit(item)}</span>
          </React.Fragment>
        )}
      </div>
    );
  }

  // 获取目标单位
  public getGoalUnit(item: IGoal): string {
    if (item.goal_type == 3) {
      return `${item.daily_goal_val}${this.units[item.daily_val_type]}`;
    } else {
      return `${item.goal_val}${this.units[item.val_type]}`;
    }
  }

  render() {
    const { goals, tempBtnColor } = this.props;
    return (
      <div className={PREFIX}>
        {goals.length &&
          goals.map((item) => {
            return this.renderGoals(item);
          })}
        <div
          className={classNames(`${PREFIX}-confirmBtn`, {
            ["is-iphonex"]: isIosBangsDevice,
          })}
          style={{
            backgroundColor: tempBtnColor,
          }}
          onClick={this.handleSubmit}
        >
          <a
            className={`${PREFIX}-confirmBtnContent`}
            href="javascript:void(0)"
          >
            确定报名
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    tempBtnColor: tempBtnColorSelecor(state),
  };
};

export default connect(mapStateToProps)(ClubActivityGoal);
